<template>
	<div>
		<div class="d-flex justify-content-center">
			<div class="login-wid login-p">
				<div class="ftr-1-25 ftw600 cl-black">
					{{$t('login.becomeMemberNow')}}
				</div>
				<div class="mt-4">
				    {{ $t('userMySetting.name') }}
				</div>
				<a-input v-model:value="form.nickname" v-if="form.type==1" :maxlength="15" :placeholder="$t('userMySetting.inputNamePlaceholder')" class="ft16 mt-2"
				    style="height: 40px;" />
				<a-input v-model:value="form.name" v-if="form.type==2"  :maxlength="15" :placeholder="$t('userMySetting.inputNamePlaceholder')" class="ft16 mt-2"
				    style="height: 40px;" />
				<div class="mt-1">
					{{ $t('login.nameHint') }}
				</div>
				<div class="flex mt-3 alcenter">
					<div class="mr10">
					    {{ $t('userMySetting.iam') }}:
					</div>
					 <a-radio-group v-model:value="form.type">
					    <a-radio :value="1">{{$t('userMySetting.studentsOrParents')}}</a-radio>
					    <a-radio :value="2">{{$t('userMySetting.teacher')}}</a-radio>
					  </a-radio-group>
					<!-- <a-checkbox-group v-model:value="form.type">
						<a-checkbox :value="1">{{$t('userMySetting.studentsOrParents')}}</a-checkbox>
						<a-checkbox :value="2">{{$t('userMySetting.teacher')}}</a-checkbox>
					</a-checkbox-group> -->
				</div>
				<div class="row mt-4" v-if="form.type==1">
					<div class="col-sm-6">
						<div class="mt-3">
						    {{ $t('login.mainContent1') }}
						</div>
						<a-select size="large" style="width: 100%;" class="mt-2" v-model="form.school_type_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in schoolTypeList">
								{{item.name}}
							</a-select-option>
						</a-select>
						<div class="mt-3">
						    {{ $t('login.mainContent2') }}
						</div>
						<a-select size="large" style="width: 100%;" class="mt-2" v-model="form.course">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in courseList">
								{{item.name}}
							</a-select-option>
							
						</a-select>
						<div class="mt-3">
						    {{ $t('login.mainContent3') }}
						</div>
						<a-select size="large" style="width: 100%;" mode="multiple" :placeholder="$t('common.select')" class="mt-2" v-model="form.course_ids">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in courseTypeList">
								{{item.name}}
							</a-select-option>
						</a-select>
						<div class="mt-3">
						    {{ $t('login.mainContent4') }}
						</div>
						<a-input class="mt-2" :placeholder="$t('userMySetting.inputEmailPlaceholder')" v-model="form.learning_objectives"> </a-input>
					</div>
					<div class="col-sm">
						<div class="mt-3">
						    {{ $t('login.mainContent5') }}
						</div>
						<a-select size="large" style="width: 100%;" class="mt-2" v-model="form.school_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in schoolList">
								{{item.name}}
							</a-select-option>
						</a-select>
						<div class="mt-3">
						    {{ $t('login.mainContent6') }}
						</div>
						<a-select size="large" style="width: 100%;" class="mt-2" v-model="form.grade">
							<a-select-option :value="item.name" v-for="(item,index) in levelListCommon">
								{{item.name}}
							</a-select-option>
						</a-select>
						<div class="mt-3">
						    {{ $t('login.mainContent7') }}
						</div>
						<a-input class="mt-2" :placeholder="$t('userMySetting.inputEmailPlaceholder')" v-model="form.paper_language"> </a-input>
						<div class="mt-3">
						    {{ $t('login.mainContent8') }}
						</div>
						<a-input class="mt-2" :placeholder="$t('userMySetting.inputEmailPlaceholder')" v-model="form.course_language"> </a-input>
					</div>
				</div>
				<div class="row mt-4" v-else>
					<div class="col-sm-6">
						<div class="mt-3">
						    {{ $t('login.mainContent10') }}
						</div>
						<a-select size="large" style="width: 100%;" class="mt-2" v-model="form.education_background_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in educationBackgroundList">
								{{item.name}}
							</a-select-option>
						</a-select>
						<div class="mt-3">
						    {{ $t('login.mainContent11') }}
						</div>
						<a-select size="large" style="width: 100%;" mode="multiple" :placeholder="$t('common.select')" class="mt-2" v-model="form.professor_level_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in professorLevelList">
								{{item.name}}
							</a-select-option>
						</a-select>
						<div class="mt-3">
						    {{ $t('login.mainContent12') }}
						</div>
						<a-select size="large" style="width: 100%;" class="mt-2" v-model="form.special_educational_experience_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in specialEducationalExperienceList">
								{{item.name}}
							</a-select-option>
						</a-select>
					</div>
					<div class="col-sm">
						<div class="flex center">
							<div style="width: 60%;">
								<div class="mt-3">
								    {{ $t('login.mainContent13') }}
								</div>
								<a-select size="large" :placeholder="$t('common.select')" class="mt-2" style="width: 100%;" v-model="language_id">
									<a-select-option :value="0" >
										{{$t('common.select')}}
									</a-select-option>
									<a-select-option :value="item.id" v-for="(item,index) in languageList">
										{{item.name}}
									</a-select-option>
								</a-select>
							</div>
							<div style="width: 40%;">
								<div class="mt-3">
								    {{ $t('teacherSet.level') }}
								</div>
								<a-select size="large"  class="mt-2" style="width: 100%;"v-model="language_level_id" @change="changeLevel()">
									<a-select-option :value="0" >
										{{$t('common.select')}}
									</a-select-option>
									<a-select-option :value="item.id" v-for="(item,index) in languageLevelList">
										{{item.name}}
									</a-select-option>
								</a-select>
							</div>
						</div>
						<div class="mt-2 flex" v-if="form.teacher_language.length>0">
							<div v-for="(item,index) in form.teacher_language" class="pos-re border-gray mr10">
								<div class="ml10 p-2 bg-w ft14" >
									{{item.language_name}} {{item.language_level_name}}
								</div>
								<div class="pos-ab" style="top: -13px;right: -5px;" @click="form.teacher_language.splice(index,1)">
									<a-icon type="close-circle" ></a-icon>
								</div>
								
							</div>
						</div>
						<div class="mt-3">
						    {{ $t('login.mainContent14') }}
						</div>
						<a-select size="large" style="width: 100%;" mode="multiple" :placeholder="$t('common.select')" class="mt-2" v-model="form.course_classify_id">
							<a-select-option :value="0" >
								{{$t('common.select')}}
							</a-select-option>
							<a-select-option :value="item.id" v-for="(item,index) in courseTypeList">
								{{item.name}}
							</a-select-option>
						</a-select>
					</div>
				</div>
				
				<div class="flex mt-4 center">
					<button type="button" class="btn btn-secondary" :disabled=" !getBtnUsed" style="width: 200px;"
					@click="form.type==1?updateInfo():teacherUpdate()">
						{{ $t('login.mainContent9') }}
					</button>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				form:{
					nickname:'',
					type:1,
					grade:'小一',//年级
					school_type_id:0,//学校类型ID
					school_id:0,//学校ID
					course:0,//就读课程
					course_ids:undefined,//想学的科目
					paper_language:'',//考卷语言
					learning_objectives:'',//学习目标
					course_language:'',//授课语言要求
					
					name:'',
					education_background_id:0,//學歷，最高教育程度
					teacher_language:[],//會説語言
					language_level_id:0,//语言等级ID
					professor_level_id:undefined,//教授级别ID
					special_educational_experience_id:0,//特殊教育经验ID
					course_classify_id:undefined,//教授的科目
					
				},
				schoolTypeList:[],
				schoolList:[],
				courseList:[],
				courseTypeList:[],
				educationBackgroundList:[],
				languageList:[],
				languageLevelList:[],
				professorLevelList:[],
				specialEducationalExperienceList:[],
				
				language_id:0,
				language_level_id:0
				
				
			}
		},
		async created() {
			let arr = await this.informationIntegration(['schoolType','school','educationBackground','language','languageLevel','professorLevel','specialEducationalExperience'])
			this.schoolTypeList = arr.list.schoolType.list
			this.schoolList = arr.list.school.list
			this.educationBackgroundList = arr.list.educationBackground.list
			this.languageList = arr.list.language.list
			this.languageLevelList= arr.list.languageLevel.list
			this.professorLevelList =arr.list.professorLevel.list
			this.specialEducationalExperienceList=arr.list.specialEducationalExperience.list
			
			// console.log("this.schoolTypeList",this.schoolTypeList);
			// console.log("this.schoolList",this.schoolList);
			this.getCourseList()
			this.classifyList()
		},
		computed:{
			getBtnUsed(){
				if(this.form.type==1){
					if(this.form.nickname!=''&&this.form.school_type_id!=0&&this.form.school_id!=0&&this.form.course!=0
					&&this.form.course_ids!=undefined&&this.form.paper_language!=''&&this.form.learning_objectives!=''&&this.form.course_language!=''){
						return true
					}else{
						return false
					}
				}else{
					if(this.form.name!=''&&this.form.education_background_id!=0&&this.form.teacher_language!=[]&&
					this.form.professor_level_id!=undefined&&this.form.special_educational_experience_id!=0&&this.form.course_classify_id!=undefined){
						return true
					}else{
						return false
					}
				}
			}
		},
		methods:{
			changeLevel(){
				let language_name='',language_level_name = ''
				this.languageList.forEach((item,index)=>{
					if(item.id==this.language_id){
						language_name = item.name
					}
				})
				
				this.languageLevelList.forEach((item,index)=>{
					if(item.id==this.language_level_id){
						language_level_name = item.name
					}
				})
				this.form.teacher_language.push({
					language_level_name,
					language_name,
					language_id:this.language_id,
					language_level_id:this.language_level_id
				})
			},
			getCourseList() {
				this.$http.api('course/courseList', {
			
				}).then(res => {
					this.courseList = res.list
				})
			},
			classifyList(){
				this.$http.api('course/classifyList',{
					// includeCourse:1
				}).then(res=>{
					this.courseTypeList = res.list
					
				})
			},
			updateInfo() {
				this.$confirm({
					title: this.$t('common.completeRegistration'),
					okText: this.$t('common.confirm'),
					okType: 'danger',
					cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('user/update', this.form).then(res => {
						    this.$message.success(this.$t('common.operationSuccessful'),2,()=>{
								this.setUserInfo()
								this.$router.push('/')
							})
						})
					},
				});

			},
			teacherUpdate() {
				this.$confirm({
					title: this.$t('common.completeRegistration'),
					okText: this.$t('common.confirm'),
					okType: 'danger',
					cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/teacher/update', this.form).then(res => {
							this.$message.success(this.$t('common.operationSuccessful'),2,()=>{
								this.setUserInfo()
								this.$router.push('/')
							})
						})
					},
				});
				
				
			},
		}
	}
</script>

<style>
	.login-wid {
		width: 700px;
		padding-top: 70px;
	}
	
	@media (max-width:576px) {
		.login-wid {
			width: 100%;
			padding-top: 16px;
		}
	
		.login-p {
			padding: 16px 40px;
		}
	}
</style>